import styled, { css } from 'styled-components';

import { FONT_TYPES, Spacer, Text, token, typographyMixin } from '@zillow/constellation';

const getActiveStyle = ({ activeStyleColorToken = 'colors.blue400', activeStyleBgColorToken = 'colors.blue100' }) => {
  return css`
    color: ${token(activeStyleColorToken)};
    background-color: ${token(activeStyleBgColorToken)};
  `;
};

const getInActiveStyle = ({ inActiveStyleStateActiveBgColorToken = 'colors.blue200' }) => {
  return css`
    color: ${token('colors.textDark')};

    &:hover {
      background-color: ${token('colors.blue100')};
    }

    /* clicked state */
    &:active {
      background-color: ${token(inActiveStyleStateActiveBgColorToken)};
    }
  `;
};

const getActiveTitleStyle = (props: { isActive?: boolean; activeStyleFontTypeToken?: string }) => {
  return css`
    ${typographyMixin({ ...props, fontType: props?.activeStyleFontTypeToken || FONT_TYPES.bodyHeading })}
  `;
};

const getInActiveTitleStyle = (props: { isActive?: boolean }) => {
  return css`
    ${typographyMixin({ ...props, fontType: FONT_TYPES.body })}
  `;
};

export const StyledTitleText = styled(Text)<{ isActive?: boolean; activeStyleFontTypeToken?: string }>`
  ${({ isActive = false }) => (isActive ? getActiveTitleStyle : getInActiveTitleStyle)}

  /* must be below typographyMixin */
  color: inherit;
`;

export const StyledAdaptiveAnchorContainer = styled(Spacer)`
  color: inherit;
  text-decoration: none;
`;

export const StyledNavigationItem = styled.div<{
  activeStyleColorToken?: string;
  activeStyleBgColorToken?: string;
  inActiveStyleStateActiveBgColorToken?: string;
  isActive?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 8px 12px;

  height: 40px;
  border-radius: 8px;
  border-color: ${token('colors.white')};

  /* focused-visible: applies the focus indicator selectively based on the user's interaction mode */
  &:focus-visible {
    background-color: ${token('colors.blue100')};
    outline: 2px solid ${token('colors.blue400')};
    outline-offset: -2px;
  }

  ${({ isActive = false }) => (isActive ? getActiveStyle : getInActiveStyle)}
`;

export const StyledLeadingIconContainer = styled.div`
  margin-right: 8px;
`;

export const StyledTrailingIconContainer = styled.div`
  // offset position of the icon in order to vertically center correctly
  position: relative;
  top: 1px;

  margin-left: auto;
`;

export const StyledLineHeight = styled.div`
  line-height: 0;
`;
